import axios from "axios"
import router from "@/router"

const BASE_URL = process.env.VUE_APP_API_BASE || ""

const http = axios.create({
  baseURL: BASE_URL,
  timeout: 15000
})

// 请求拦截器 — 携带 token 和 siteId
http.interceptors.request.use(config => {
  const token = localStorage.getItem("token")
  if (token) {
    config.headers.Authorization = "Bearer " + token
  }
  const site = JSON.parse(localStorage.getItem("Site") || "null")
  if (site && site.id) {
    config.headers.siteId = site.id
  }
  return config
})

// 响应拦截器
http.interceptors.response.use(
  res => res.data,
  err => {
    if (err.response && err.response.status === 401) {
      const hadToken = !!localStorage.getItem("token")
      localStorage.removeItem("token")
      localStorage.removeItem("info")
      if (hadToken) router.replace({ name: "Login" })
    }
    return Promise.reject(err)
  }
)

export default http
